import {checkResultLine} from "./checkResultLine";

export function animateResultLine() {
    checkResultLine();
    $(window).scroll(function () {
        checkResultLine();
    });
    $(window).resize(function () {
        checkResultLine();
    });
}

